import type React from "react";

interface MarketingHeaderProps {
	title?: string;
	titleIcon?: React.ComponentType<{ className?: string }>;
	heading: string;
	description?: string;
}

export function MarketingHeader({
	title,
	titleIcon: TitleIcon,
	heading,
	description,
}: MarketingHeaderProps) {
	return (
		<header className="mx-auto mb-16 mt-14 max-w-3xl text-center">
			{(title || TitleIcon) && (
				<div className="inline-flex items-center gap-2 rounded-full border border-border/80 bg-muted/40 px-4 py-1.5 text-sm font-medium text-muted-foreground backdrop-blur-sm">
					{TitleIcon && <TitleIcon className="size-4 text-primary" />}
					{title && <span>{title}</span>}
				</div>
			)}
			<h1 className="mt-4 max-w-2xl mx-auto text-balance text-4xl font-semibold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
				{heading}
			</h1>
			{description && (
				<p
					className="mx-auto mt-6 max-w-2xl text-pretty text-base text-muted-foreground sm:text-lg"
					// biome-ignore lint/security/noDangerouslySetInnerHtml: This is purely for marketing purposes and does not take user input.
					dangerouslySetInnerHTML={{ __html: description }}
				/>
			)}
		</header>
	);
}
